import React from 'react';
import FormRow from '../../../../../../components/FormRow';
import Field from '../../../../../../components/Field';

export default function RowMid({ styles, rsStyles, f, errors = {} }) {
  return (
    <FormRow className={rsStyles.rowSpinnersMid}>
      <Field label="Description" className={styles.full} error={errors?.note}>
        <input
          className={styles.tallInput}
          type="text"
          placeholder="Enter description or notes"
          value={f.note}
          onChange={e => f.setNote(e.target.value)}
        />
      </Field>
    </FormRow>
  );
}

